<template>
  <v-dialog :model-value="value" width="500px" @keydown.esc="cancel" @click:outside="cancel">
    <BaseDialogCard :title="tkey('title')" @close="cancel">
      <p class="text-h6 pt-5">{{ tkey('message') }}</p>

      <template #footer>
        <v-card-actions class="justify-lg-end pa-0">
          <v-btn secondary @click="cancel">
            {{ tkey('cancel') }}
          </v-btn>
          <v-btn primary variant="flat" class="outlined-btn" @click="confirm">
            {{ tkey('continue') }}
          </v-btn>
        </v-card-actions>
      </template>
    </BaseDialogCard>
  </v-dialog>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const { tkey } = useInternationalization('workpackagePage.scope.syntheticWarningDialog');
    return { tkey };
  },

  methods: {
    confirm() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
